// Code generated by protoc-gen-ts_proto. DO NOT EDIT.
// versions:
//   protoc-gen-ts_proto  v2.7.0
//   protoc               unknown
// source: fight/model/enums/ImmafMmaWeightClassPt.proto

/* eslint-disable */

export const protobufPackage = "io.teamsillim.fightbracket.idl.fight.model";

/**
 * IMMAF 종합격투기 체급 (2024년 6월 개정 기준)
 *
 * 부 이름은 IMMAF 표기(유스 C · B · A)를 그대로 쓴다 — 「중등부」와 「미들급」이 둘 다 MIDDLE 로 겹치지 않게 하기 위함이다.
 *   유스 C = 초등부(12~13세) / 유스 B = 중등부(14~15세) / 유스 A = 고등부(16~17세) / 성인부 = 주니어 · 시니어 공통
 * 유스 C · B 는 남녀 공통이고 체급명 없이 체중 구간만 쓴다.
 * 유스 A · 성인부는 남 · 여의 상한이 같으므로 체급명 하나로 두고, 참가 가능 성별은 도메인 쪽 메타로 둔다
 * (아톰급은 여성 전용, 미들급 이상은 남성 전용).
 */
export enum ImmafMmaWeightClassPayload {
  IMMAF_WEIGHT_CLASS_UNKNOWN = 0,
  /** IMMAF_YOUTH_C_31KG - 유스 C · 초등부 (-31kg) */
  IMMAF_YOUTH_C_31KG = 1,
  /** IMMAF_YOUTH_C_34KG - 유스 C · 초등부 (-34kg) */
  IMMAF_YOUTH_C_34KG = 2,
  /** IMMAF_YOUTH_C_37KG - 유스 C · 초등부 (-37kg) */
  IMMAF_YOUTH_C_37KG = 3,
  /** IMMAF_YOUTH_C_40KG - 유스 C · 초등부 (-40kg) */
  IMMAF_YOUTH_C_40KG = 4,
  /** IMMAF_YOUTH_C_44KG - 유스 C · 초등부 (-44kg) */
  IMMAF_YOUTH_C_44KG = 5,
  /** IMMAF_YOUTH_C_48KG - 유스 C · 초등부 (-48kg) */
  IMMAF_YOUTH_C_48KG = 6,
  /** IMMAF_YOUTH_C_52KG - 유스 C · 초등부 (-52kg) */
  IMMAF_YOUTH_C_52KG = 7,
  /** IMMAF_YOUTH_C_57KG - 유스 C · 초등부 (-57kg) */
  IMMAF_YOUTH_C_57KG = 8,
  /** IMMAF_YOUTH_C_OVER_57KG - 유스 C · 초등부 (+57kg, 최대 62kg) */
  IMMAF_YOUTH_C_OVER_57KG = 9,
  /** IMMAF_YOUTH_B_40KG - 유스 B · 중등부 (-40kg) */
  IMMAF_YOUTH_B_40KG = 10,
  /** IMMAF_YOUTH_B_44KG - 유스 B · 중등부 (-44kg) */
  IMMAF_YOUTH_B_44KG = 11,
  /** IMMAF_YOUTH_B_48KG - 유스 B · 중등부 (-48kg) */
  IMMAF_YOUTH_B_48KG = 12,
  /** IMMAF_YOUTH_B_52KG - 유스 B · 중등부 (-52kg) */
  IMMAF_YOUTH_B_52KG = 13,
  /** IMMAF_YOUTH_B_57KG - 유스 B · 중등부 (-57kg) */
  IMMAF_YOUTH_B_57KG = 14,
  /** IMMAF_YOUTH_B_62KG - 유스 B · 중등부 (-62kg) */
  IMMAF_YOUTH_B_62KG = 15,
  /** IMMAF_YOUTH_B_67KG - 유스 B · 중등부 (-67kg) */
  IMMAF_YOUTH_B_67KG = 16,
  /** IMMAF_YOUTH_B_72KG - 유스 B · 중등부 (-72kg) */
  IMMAF_YOUTH_B_72KG = 17,
  /** IMMAF_YOUTH_B_OVER_72KG - 유스 B · 중등부 (+72kg, 최대 77.1kg) */
  IMMAF_YOUTH_B_OVER_72KG = 18,
  /** IMMAF_YOUTH_A_ATOM - 유스 A · 고등부 아톰급 (여 -47.7kg) */
  IMMAF_YOUTH_A_ATOM = 19,
  /** IMMAF_YOUTH_A_STRAW - 유스 A · 고등부 스트로급 (-52.2kg) */
  IMMAF_YOUTH_A_STRAW = 20,
  /** IMMAF_YOUTH_A_FLY - 유스 A · 고등부 플라이급 (-56.7kg) */
  IMMAF_YOUTH_A_FLY = 21,
  /** IMMAF_YOUTH_A_BANTAM - 유스 A · 고등부 밴텀급 (-61.2kg) */
  IMMAF_YOUTH_A_BANTAM = 22,
  /** IMMAF_YOUTH_A_FEATHER - 유스 A · 고등부 페더급 (-65.8kg) */
  IMMAF_YOUTH_A_FEATHER = 23,
  /** IMMAF_YOUTH_A_LIGHT - 유스 A · 고등부 라이트급 (-70.3kg) */
  IMMAF_YOUTH_A_LIGHT = 24,
  /** IMMAF_YOUTH_A_WELTER - 유스 A · 고등부 웰터급 (-77.1kg, 여성은 상한 최대 5kg 차 허용) */
  IMMAF_YOUTH_A_WELTER = 25,
  /** IMMAF_YOUTH_A_MIDDLE - 유스 A · 고등부 미들급 (남 -83.9kg) */
  IMMAF_YOUTH_A_MIDDLE = 26,
  /** IMMAF_YOUTH_A_LIGHT_HEAVY - 유스 A · 고등부 라이트헤비급 (남 -93.0kg) */
  IMMAF_YOUTH_A_LIGHT_HEAVY = 27,
  /** IMMAF_YOUTH_A_HEAVY - 유스 A · 고등부 헤비급 (남 -120.2kg) */
  IMMAF_YOUTH_A_HEAVY = 28,
  /** IMMAF_ADULT_ATOM - 성인부 아톰급 (여 -47.6kg) */
  IMMAF_ADULT_ATOM = 29,
  /** IMMAF_ADULT_STRAW - 성인부 스트로급 (-52.2kg) */
  IMMAF_ADULT_STRAW = 30,
  /** IMMAF_ADULT_FLY - 성인부 플라이급 (-56.7kg) */
  IMMAF_ADULT_FLY = 31,
  /** IMMAF_ADULT_BANTAM - 성인부 밴텀급 (-61.2kg) */
  IMMAF_ADULT_BANTAM = 32,
  /** IMMAF_ADULT_FEATHER - 성인부 페더급 (-65.8kg) */
  IMMAF_ADULT_FEATHER = 33,
  /** IMMAF_ADULT_LIGHT - 성인부 라이트급 (-70.3kg) */
  IMMAF_ADULT_LIGHT = 34,
  /** IMMAF_ADULT_SUPER_LIGHT - 성인부 슈퍼라이트급 (-74.8kg, 신설) */
  IMMAF_ADULT_SUPER_LIGHT = 35,
  /** IMMAF_ADULT_SUPER_WELTER - 성인부 슈퍼웰터급 (-79.4kg, 신설) */
  IMMAF_ADULT_SUPER_WELTER = 36,
  /** IMMAF_ADULT_MIDDLE - 성인부 미들급 (남 -83.9kg) */
  IMMAF_ADULT_MIDDLE = 37,
  /** IMMAF_ADULT_SUPER_MIDDLE - 성인부 슈퍼미들급 (남 -88.4kg, 신설) */
  IMMAF_ADULT_SUPER_MIDDLE = 38,
  /** IMMAF_ADULT_LIGHT_HEAVY - 성인부 라이트헤비급 (남 -93.0kg) */
  IMMAF_ADULT_LIGHT_HEAVY = 39,
  /** IMMAF_ADULT_HEAVY - 성인부 헤비급 (남 -97.0kg) */
  IMMAF_ADULT_HEAVY = 40,
  /** IMMAF_ADULT_SUPER_HEAVY - 성인부 슈퍼헤비급 (남 +97.0kg) */
  IMMAF_ADULT_SUPER_HEAVY = 41,
  UNRECOGNIZED = -1,
}

export function immafMmaWeightClassPayloadFromJSON(object: any): ImmafMmaWeightClassPayload {
  switch (object) {
    case 0:
    case "IMMAF_WEIGHT_CLASS_UNKNOWN":
      return ImmafMmaWeightClassPayload.IMMAF_WEIGHT_CLASS_UNKNOWN;
    case 1:
    case "IMMAF_YOUTH_C_31KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_31KG;
    case 2:
    case "IMMAF_YOUTH_C_34KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_34KG;
    case 3:
    case "IMMAF_YOUTH_C_37KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_37KG;
    case 4:
    case "IMMAF_YOUTH_C_40KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_40KG;
    case 5:
    case "IMMAF_YOUTH_C_44KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_44KG;
    case 6:
    case "IMMAF_YOUTH_C_48KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_48KG;
    case 7:
    case "IMMAF_YOUTH_C_52KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_52KG;
    case 8:
    case "IMMAF_YOUTH_C_57KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_57KG;
    case 9:
    case "IMMAF_YOUTH_C_OVER_57KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_OVER_57KG;
    case 10:
    case "IMMAF_YOUTH_B_40KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_40KG;
    case 11:
    case "IMMAF_YOUTH_B_44KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_44KG;
    case 12:
    case "IMMAF_YOUTH_B_48KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_48KG;
    case 13:
    case "IMMAF_YOUTH_B_52KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_52KG;
    case 14:
    case "IMMAF_YOUTH_B_57KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_57KG;
    case 15:
    case "IMMAF_YOUTH_B_62KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_62KG;
    case 16:
    case "IMMAF_YOUTH_B_67KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_67KG;
    case 17:
    case "IMMAF_YOUTH_B_72KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_72KG;
    case 18:
    case "IMMAF_YOUTH_B_OVER_72KG":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_OVER_72KG;
    case 19:
    case "IMMAF_YOUTH_A_ATOM":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_ATOM;
    case 20:
    case "IMMAF_YOUTH_A_STRAW":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_STRAW;
    case 21:
    case "IMMAF_YOUTH_A_FLY":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_FLY;
    case 22:
    case "IMMAF_YOUTH_A_BANTAM":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_BANTAM;
    case 23:
    case "IMMAF_YOUTH_A_FEATHER":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_FEATHER;
    case 24:
    case "IMMAF_YOUTH_A_LIGHT":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_LIGHT;
    case 25:
    case "IMMAF_YOUTH_A_WELTER":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_WELTER;
    case 26:
    case "IMMAF_YOUTH_A_MIDDLE":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_MIDDLE;
    case 27:
    case "IMMAF_YOUTH_A_LIGHT_HEAVY":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_LIGHT_HEAVY;
    case 28:
    case "IMMAF_YOUTH_A_HEAVY":
      return ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_HEAVY;
    case 29:
    case "IMMAF_ADULT_ATOM":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_ATOM;
    case 30:
    case "IMMAF_ADULT_STRAW":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_STRAW;
    case 31:
    case "IMMAF_ADULT_FLY":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_FLY;
    case 32:
    case "IMMAF_ADULT_BANTAM":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_BANTAM;
    case 33:
    case "IMMAF_ADULT_FEATHER":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_FEATHER;
    case 34:
    case "IMMAF_ADULT_LIGHT":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_LIGHT;
    case 35:
    case "IMMAF_ADULT_SUPER_LIGHT":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_SUPER_LIGHT;
    case 36:
    case "IMMAF_ADULT_SUPER_WELTER":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_SUPER_WELTER;
    case 37:
    case "IMMAF_ADULT_MIDDLE":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_MIDDLE;
    case 38:
    case "IMMAF_ADULT_SUPER_MIDDLE":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_SUPER_MIDDLE;
    case 39:
    case "IMMAF_ADULT_LIGHT_HEAVY":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_LIGHT_HEAVY;
    case 40:
    case "IMMAF_ADULT_HEAVY":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_HEAVY;
    case 41:
    case "IMMAF_ADULT_SUPER_HEAVY":
      return ImmafMmaWeightClassPayload.IMMAF_ADULT_SUPER_HEAVY;
    case -1:
    case "UNRECOGNIZED":
    default:
      return ImmafMmaWeightClassPayload.UNRECOGNIZED;
  }
}

export function immafMmaWeightClassPayloadToJSON(object: ImmafMmaWeightClassPayload): string {
  switch (object) {
    case ImmafMmaWeightClassPayload.IMMAF_WEIGHT_CLASS_UNKNOWN:
      return "IMMAF_WEIGHT_CLASS_UNKNOWN";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_31KG:
      return "IMMAF_YOUTH_C_31KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_34KG:
      return "IMMAF_YOUTH_C_34KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_37KG:
      return "IMMAF_YOUTH_C_37KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_40KG:
      return "IMMAF_YOUTH_C_40KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_44KG:
      return "IMMAF_YOUTH_C_44KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_48KG:
      return "IMMAF_YOUTH_C_48KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_52KG:
      return "IMMAF_YOUTH_C_52KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_57KG:
      return "IMMAF_YOUTH_C_57KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_C_OVER_57KG:
      return "IMMAF_YOUTH_C_OVER_57KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_40KG:
      return "IMMAF_YOUTH_B_40KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_44KG:
      return "IMMAF_YOUTH_B_44KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_48KG:
      return "IMMAF_YOUTH_B_48KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_52KG:
      return "IMMAF_YOUTH_B_52KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_57KG:
      return "IMMAF_YOUTH_B_57KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_62KG:
      return "IMMAF_YOUTH_B_62KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_67KG:
      return "IMMAF_YOUTH_B_67KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_72KG:
      return "IMMAF_YOUTH_B_72KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_B_OVER_72KG:
      return "IMMAF_YOUTH_B_OVER_72KG";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_ATOM:
      return "IMMAF_YOUTH_A_ATOM";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_STRAW:
      return "IMMAF_YOUTH_A_STRAW";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_FLY:
      return "IMMAF_YOUTH_A_FLY";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_BANTAM:
      return "IMMAF_YOUTH_A_BANTAM";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_FEATHER:
      return "IMMAF_YOUTH_A_FEATHER";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_LIGHT:
      return "IMMAF_YOUTH_A_LIGHT";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_WELTER:
      return "IMMAF_YOUTH_A_WELTER";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_MIDDLE:
      return "IMMAF_YOUTH_A_MIDDLE";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_LIGHT_HEAVY:
      return "IMMAF_YOUTH_A_LIGHT_HEAVY";
    case ImmafMmaWeightClassPayload.IMMAF_YOUTH_A_HEAVY:
      return "IMMAF_YOUTH_A_HEAVY";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_ATOM:
      return "IMMAF_ADULT_ATOM";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_STRAW:
      return "IMMAF_ADULT_STRAW";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_FLY:
      return "IMMAF_ADULT_FLY";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_BANTAM:
      return "IMMAF_ADULT_BANTAM";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_FEATHER:
      return "IMMAF_ADULT_FEATHER";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_LIGHT:
      return "IMMAF_ADULT_LIGHT";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_SUPER_LIGHT:
      return "IMMAF_ADULT_SUPER_LIGHT";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_SUPER_WELTER:
      return "IMMAF_ADULT_SUPER_WELTER";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_MIDDLE:
      return "IMMAF_ADULT_MIDDLE";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_SUPER_MIDDLE:
      return "IMMAF_ADULT_SUPER_MIDDLE";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_LIGHT_HEAVY:
      return "IMMAF_ADULT_LIGHT_HEAVY";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_HEAVY:
      return "IMMAF_ADULT_HEAVY";
    case ImmafMmaWeightClassPayload.IMMAF_ADULT_SUPER_HEAVY:
      return "IMMAF_ADULT_SUPER_HEAVY";
    case ImmafMmaWeightClassPayload.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}
